import React from 'react';
import { Container, Button, Stack} from '@mui/material';
import Header from '../components/layout/Header';
import StandardDonForm from '../components/forms/standardDon';
import DonateurInfoSection from '../components/sections/DonateurInfoSection';
import RecapSection from '../components/sections/RecapSection';

export const DonContext = React.createContext();
const StandardDon = () => {
  const [isAnonyme, setIsAnonyme] = React.useState(false);
  const [egliseNum, setEglise] = React.useState(localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).eglise : '');
  const [dime, setDime] = React.useState('');
  const [off_global, setOff_global] = React.useState('');
  const [offrandesFederale, setOffrandesFederale] = React.useState([{libelle:'', montant:0, compte:''}]);
  const [offrandesLocale, setOffrandesLocale] = React.useState([{libelle:'', montant:0, compte:''}]);
  
  const total = React.useMemo(()=>[dime,off_global, ...offrandesFederale.map(off=>off.montant), ...offrandesLocale.map(off=>off.montant)].reduce((acc, val) => {
    const num = Number(val);
    return acc + (isNaN(num) ? 0 : num);
  }, 0), [dime, off_global, offrandesFederale, offrandesLocale]);
  
  return (
    <>
      <Header />
      <DonContext.Provider value={{isAnonyme, setIsAnonyme, egliseNum, setEglise, dime, setDime, off_global, setOff_global, offrandesFederale, setOffrandesFederale, offrandesLocale, setOffrandesLocale, total}}>
        <Container maxWidth="sm" sx={{ mt: 4, width: '100%', px: { xs: 1, sm: 2 } }}>
          <StandardDonForm />
          {/* <DonateurInfoSection /> */}
          <RecapSection />
        </Container>
        {/* <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} sx={{ mt: 2, mb: 4, px: { xs: 1, sm: 2 }, maxWidth: '100%' }}>
          <Button variant="outlined" sx={{ width: { xs: '100%', sm: 'auto' } }}>Retour</Button>
          <Button variant="contained" sx={{ width: { xs: '100%', sm: 'auto' } }}>Continuer</Button>
        </Stack> */}
      </DonContext.Provider>
    </>
  );
};

export default StandardDon;